import { classnames } from '@aibees/shared/utils';
import { forwardRef, lazy, Suspense, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichmentPageProps as Props, Tab } from './types';
import { LoadingScreen } from '@aibees/shared/components';

const CsvEnrichment = lazy(() =>
  import('@aibees/elephant/components/csv-enrichment').then((module) => ({
    default: module.CsvEnrichment,
  }))
);

const _EnrichmentTabs = lazy(() =>
  import('@aibees/elephant/components/enrichment-tabs').then((module) => ({
    default: module.EnrichmentTabs,
  }))
);

const OverviewEnrichment = lazy(() =>
  import('@aibees/elephant/components/overview-enrichment').then((module) => ({
    default: module.OverviewEnrichment,
  }))
);

export const EnrichmentPage = forwardRef<HTMLDivElement, Props>(
  ({ className }, ref) => {
    const [tabs, setTabs] = useState<Tab[]>([
      {
        title: 'Overview',
        component: (
          <Suspense fallback={<LoadingScreen />}>
            <OverviewEnrichment />
          </Suspense>
        ),
        active: false,
      },
      {
        title: 'CSV Enrichment',
        component: (
          <Suspense fallback={<LoadingScreen />}>
            <CsvEnrichment />
          </Suspense>
        ),
        active: true,
      },
    ]);

    const _handleChangeTabs = (tab: Tab) => {
      setTabs((prev) => {
        return prev.map((t) =>
          t.title === tab.title
            ? { ...t, active: !t.active }
            : { ...t, active: false }
        );
      });
    };

    const _activeComponent = tabs.find((t) => t.active)?.component;

    return (
      <Styled.Wrapper
        className={classnames('EnrichmentPage', className)}
        ref={ref}
        sx={SX.root}
      >
        <CsvEnrichment />
      </Styled.Wrapper>
    );
  }
);
